import { EVENT_HIDE_GAME_SEARCH_MODAL, EVENT_SHOW_GAME_SEARCH_MODAL } from "../constants";

export const hideGameSearchModal = () => {
  window.dispatchEvent(new CustomEvent(EVENT_HIDE_GAME_SEARCH_MODAL));
};

export const showGameSearchModal = () => {
  window.dispatchEvent(new CustomEvent(EVENT_SHOW_GAME_SEARCH_MODAL));
};
